import { GenericKeyResponseDto } from '../../api/kmsapiclient'
import { KeyInfo } from '../../components/common/types'
import { Keys } from '../reducers/initialState'

import * as types from './actionTypes'
import { BaseActionType } from './actionTypes'

export const loadSigningKeysSuccess = (signingKeys: Keys): BaseActionType => ({
  type: types.LOAD_SIGNING_KEYS_SUCCESS,
  payload: signingKeys,
})

export const loadMoreSigningKeysSuccess = (
  signingKeys: Keys,
): BaseActionType => ({
  type: types.LOAD_MORE_SIGNING_KEYS_SUCCESS,
  payload: signingKeys,
})

export const updateSigningKeySuccess = (
  signingKey: GenericKeyResponseDto,
): BaseActionType => ({
  type: types.UPDATE_SIGNING_KEYS_SUCCESS,
  payload: signingKey,
})

export const deleteSigningKeySuccess = (
  signingKey: KeyInfo,
): BaseActionType => ({
  type: types.DELETE_SIGNING_KEYS_SUCCESS,
  payload: signingKey,
})

export const addSigningKeySuccess = (
  signingKey: GenericKeyResponseDto,
): BaseActionType => ({
  type: types.UPLOAD_SIGNING_KEYS_SUCCESS,
  payload: signingKey,
})
